import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "day",
    standalone: true
})
export class DayPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return "Not Selected";
    }
    const trimmedValue = value.trim();
    switch (trimmedValue) {
      case "Mon":
        return "Monday";
      case "Tue":
        return "Tuesday";
      case "Wed":
        return "Wednesday";
      case "Thu":
        return "Thursday";
      case "Fri":
        return "Friday";
      case "Sat":
        return "Saturday";
      case "Sun":
        return "Sunday";
      default:
        return "Not Selected";
    }
  }
}
